export default "__VITE_ASSET__BcjYGzWm__"